const escapeRegExp = (text: string) => {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/@/g, '');
};

export const isItemMatching = (itemName = '', queryText: string): boolean => {
  // Include an item in the search results if name includes the current user input.

  return itemName.toLowerCase().includes(escapeRegExp(queryText.toLowerCase()));
};

export const isFirstNameMatching = (
  itemName = '',
  queryText: string,
): boolean => {
  const searchString = escapeRegExp(queryText);

  const pattern = new RegExp(`^${searchString}`, 'i');

  return pattern.test(itemName);
};

export const isLastNameMatching = (
  itemName = '',
  queryText: string,
): boolean => {
  const searchString = escapeRegExp(queryText);
  const pattern = new RegExp(` ${searchString}`, 'gi');

  return pattern.test(itemName);
};
